import { forwardRef, Ref, TextareaHTMLAttributes } from 'react';

export type TextAreaProps = TextareaHTMLAttributes<HTMLElement> & {
  label?: string | undefined;
  labelClassName?: string | undefined;
  ref?: Ref<HTMLTextAreaElement>;
};

export const CLTextarea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, labelClassName, ...props }, ref) => {
    return (
      <>
        {label && <label className={labelClassName}>{label}</label>}
        <textarea ref={ref} {...(props as any)} />
      </>
    );
  }
);
CLTextarea.displayName = 'CLTextarea';
